import { MAP_TYPES } from '@deck.gl/carto';
 
const TSN_HISTORICAL_SEGMENT_SOURCE_ID = 'tsnHistoricalSegmentSource';
 
const source = {
  id: TSN_HISTORICAL_SEGMENT_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'tsn_historical_segment',
};
 
export default source;
 